import React from "react";

const CRMIcon = ({ color = "#0A61F5" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9857 6.33329C13.1228 5.08579 15.8482 5.69662 17.2641 7.74037C18.6799 9.78412 18.3149 12.582 16.4245 14.1858C15.516 14.9591 14.3484 15.3598 13.1565 15.3072C11.9646 15.2547 10.8368 14.7528 9.99991 13.9025L6.63449 10.5C6.4112 10.2731 6.28605 9.96761 6.28605 9.64933C6.28605 9.33104 6.4112 9.02552 6.63449 8.7987C6.74437 8.6871 6.87535 8.59847 7.01982 8.53797C7.16428 8.47747 7.31933 8.44631 7.47595 8.44631C7.63257 8.44631 7.78762 8.47747 7.93208 8.53797C8.07655 8.59847 8.20753 8.6871 8.31741 8.7987L11.6828 12.2012C12.1474 12.6708 12.9007 12.6708 13.3653 12.2012C13.8299 11.7316 13.8299 10.9695 13.3653 10.5L9.99991 7.09787C9.16308 6.24751 8.03531 5.74553 6.8434 5.69288C5.6515 5.64024 4.48387 6.04084 3.57532 6.81412C1.68491 8.41787 1.32032 11.2158 2.73616 13.2595C4.15157 15.3033 6.87699 15.9137 9.01449 14.6666"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CRMIcon;
